import React, { Component } from 'react';

const myButton = (props) => {
    return(
    <button style={{borderRadius:'30px',border:"1px solid gray",background:"#fff",width:'14rem',height:"3rem"}}>{props.value}</button>
    )
}

export default myButton;